import type { FilterOptionItem } from '@/components/CHeaderFilter';
import i18n from '@/i18n';
import { mediaStore } from '@/utils/common/newMedia';

// 需求申请记录
// 账户ID
export const accountIdFilter: FilterOptionItem = {
  name: 'accountId',
  span: 12,
  component: 'select',
  label: { title: 'account_id' },
  placeholder: 'enter_multiple',
};
// 开户主体
export const entityNameFilter: FilterOptionItem = {
  name: 'entityName',
  span: 12,
  component: 'select',
  label: { title: 'account_opening_entity' },
  placeholder: 'enter_multiple',
};
// 操作日期
export const applyDateFilter: FilterOptionItem = {
  name: 'operateTime',
  component: 'dateRange',
  span: 12,
  label: { title: 'operation_time' },
};
// Unused: 媒体
export const mediumFilter: FilterOptionItem = {
  name: 'medium',
  component: 'select',
  span: 12,
  label: { title: 'media_type' },
  placeholder: 'can_select_multiple',
  options: {
    get options() {
      return mediaStore.mainMediaMap;
    },
    mode: 'multiple',
  },
};
// 状态
export const StatusEnum = {
  // 处理中、成功、失败
  PROCESSING: 1,
  SUCCESS: 2,
  FAIL: 3,
} as const;
const statusMap = [
  { label: 'processing', value: StatusEnum.PROCESSING },
  { label: 'success', value: StatusEnum.SUCCESS },
  { label: 'fail', value: StatusEnum.FAIL },
];
export const statusFilter: FilterOptionItem = {
  name: 'operateStatus',
  component: 'checkbox',
  span: 12,
  label: { title: 'application_status' },
  options: { options: statusMap, mode: 'multiple' },
};
// 发起人
export const initiatorFilter: FilterOptionItem = {
  name: 'submitter',
  component: 'input',
  span: 12,
  label: { title: 'initiator' },
};

export const BmStatusEnum = {
  MAIL_SENDING: 6,
  MAIL_PENDING: 7,
  MAIL_INVALID: 8,
} as const;
// FB - 绑定BM 状态
const bmStatusMap = [
  { label: 'email_sending', value: BmStatusEnum.MAIL_SENDING }, // 邮件发送中
  { label: 'email_pending_reply', value: BmStatusEnum.MAIL_PENDING }, // 邮件待回复
  { label: 'email_expiry', value: BmStatusEnum.MAIL_INVALID }, // 邮件失效
];
export const bmStatusFilter: FilterOptionItem = {
  name: 'operateStatus',
  component: 'select',
  span: 12,
  label: { title: 'application_status' },
  options: {
    options: [...statusMap, ...bmStatusMap]?.map((item) => ({
      ...item,
      title: i18n.t(item.label),
    })),
    mode: 'multiple',
  },
};
